<div id="showcase">
    <img src="/assets/img//showcase/11.jpeg" alt="banner" class="img-fluid w-100">
</div>
<div id="heading">
    <h1>{{title}}</h1>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item" routerLink="/"><a href="#">Home</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{title}}</li>
        </ol>
    </nav>
</div>

<div class="container-fluid pdf">
    <div class="row">
        <div class="col-12">
            <div class="card shadow-lg my-3 px-md-4">
                <h4 class="card-title text-center ">{{title}}</h4>
                <div class="card-body">
                    <div id="detail" class="text-center">
                        <pdf-viewer [src]="src" [render-text]="true" style="display: block;"
                            id="list-view"></pdf-viewer>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>